/** @file Deletes a non-root bone and everything that depends on it (via format/doc/removeEntity). */
import { throwError } from '@pose2d/format/throwError';
import { defineCommand } from '../defineCommand';
import { defineRemove } from '../_shared/defineRemove';
import { assertNotSocketBone } from '../_shared/assertNotSocketBone';

const remove = defineRemove({
  domain: 'bone',
  kind: 'bone',
  description: 'Delete a bone with its child bones, slots, constraints, sockets and timelines (a warning lists them); the root bone and generated socket bones cannot be deleted (edit the socket instead).',
});

export const command = defineCommand({
  ...remove,
  apply(draft, input, ctx) {
    const id = ctx.resolve('bone', input.target);
    if (draft.bones[id]?.parent === null) {
      throwError('VALIDATION', undefined, { path: 'target', hint: 'the root bone cannot be deleted; delete its children or re-parent them instead' });
    }
    assertNotSocketBone(draft, id);
    remove.apply(draft, input, ctx);
  },
});
